<template>
  <component :is="list.skipCardLayout?'md-card':'div'">
    <md-card-header class="md-card-header-icon md-card-header-green list-header" :class="list.hideListHeader? 'list-header-hidden' : ''">
      <template v-if="!list.hideListHeader">
        <h4 class="title">{{ list.pageTitle }}</h4>
      </template>

      <md-button id="messageListRefresh" class="md-just-icon md-simple" @click="refresh()"><md-icon>refresh</md-icon></md-button>
      <md-button v-if="!list.skipCardLayout" @click="addGroup" :disabled="isCompleteInOrder" class="md-button md-primary md-sm add-group-btn _smBtn">Add Group<md-icon class="md-small">control_point</md-icon></md-button>
      <md-button v-if="!list.skipCardLayout" @click="saveTaskOrder" :disabled="isDisabled" class="md-button md-primary md-sm add-group-btn _smBtn">Save Order<md-icon class="md-small">reorder</md-icon></md-button>
    </md-card-header>
    <component :is="list.skipCardLayout?'div':'md-card-content'">

      <div class="dynamicList-loading"
           v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>

      <md-table
        :value="queriedData"
        :md-sort.sync="list.currentSort"
        :md-sort-order.sync="list.currentSortOrder"
        :md-sort-fn="customSort"
        class="paginated-table table-striped table-hover"
      >

        <!-- Group Task columns -->
        <template v-if="list.tableData.length > 0">
          <div class="md-layout md-table-head md-sortable md-sorted _sortableHeader" :class="{ 'md-sorted-desc': !sort.asc }">
            <div class="md-layout-item md-small-size-20 _breakWord md-form-label" v-for="(_col, _index) in columns" :key="_index" @click="onSortChange(_col)">
              <md-ripple class="md-table-head-container" :md-disabled="!_col.isSortable">
                <div class="md-table-head-label">
                  <i class="md-icon md-icon-font md-icon-image md-table-sortable-icon md-theme-default" v-if="_col.isSortable && sort.key == _col.key">
                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h24v24H0V0z" fill="none"></path> 
                      <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path>
                    </svg>
                  </i>
                  {{ _col.label }}
                </div>
              </md-ripple>
            </div>
          </div>

          <div class="_root" ref="draggableRoot">
            <!-- draggable component -->
            <draggable class="list-group" handle="._parentGroup__handle" v-bind="dragOptions" @end="dragend">
              <div class="_group _parentGroup" v-for="(_group, groupIndex) in orderedGroups" :key="groupIndex">

                <i class="_parentGroup__handle fa fa-order fa fa-align-justify"></i>

                <div class="md-layout-item md-size-100 group-layout" :data-parent="getItemAsJson(_group)">
                    <div class="list-group-item item" v-for="(element, elementIndex) in orderList(_group,'order')" :key="elementIndex">
                      <draggable :id="`element-${elementIndex}`" class="list-group" handle=".elementHandle" v-bind="dragOptions" draggable="._element" group="parentGroup" @end="dragend">
                        <div class="md-layout step-layout _element" :data-child="getItemAsJson(element)" v-if="element !== 0">
                          <div class="md-layout-item md-small-size-20 _breakWord fieldText__fix"></div>
                          <div class="md-layout-item md-small-size-20 _breakWord">
                            <i class="fa fa-align-justify elementHandle"></i>
                            {{ element.subject }}
                            <accordion v-if="element.steps && element.steps.items.length" :key="element.id">
                              <ul  class="case-task-steps">
                                <li v-for="(step, elementIndex) in orderList(element.steps.items,'order')" :key="elementIndex">
                                  <input v-if="step.status == 'Open'" type="checkbox" @click="markTaskStepComplete(step)" :key="step.id" />
                                  {{step.title}}
                                </li>
                              </ul>
                            </accordion>
                          </div>
                          <div class="md-layout-item md-small-size-20 _breakWord">{{ element.status }}</div>
                          <div class="md-layout-item md-small-size-20 _breakWord">{{ element.isAvailable || (element.case && !element.case.isCompleteInOrder) ? 'Yes' : 'No' }}</div>
                          <div class="md-layout-item md-small-size-20 _breakWord overFlow">{{ element.quickNote ? element.quickNote.substring(0, 30) : '' }}</div>
                          <div class="md-layout-item md-small-size-20 _breakWord">{{ element.user ? (element.user.given_name + " " + element.user.family_name) : "" }}</div>
                          <div class="md-layout-item md-small-size-20 _breakWord">{{ element.dateDue | formatDate }}</div>
                          <div class="md-layout-item md-small-size-20 _breakWord">{{ element.createdAt | formatDate }}</div>
                          <div class="md-layout-item md-small-size-20 _breakWord">
                            <div class="md-layout md-alignment-center-left">
                              <template v-for="(action) in list.itemActions">
                                <md-button
                                  v-if="$Session.isAdminGroupMember || (!$Session.isAdminGroupMember && action.click != 'handleDelete')"
                                  :key="action.icon"
                                  :class="element.added? action.classAdded : action.class"
                                  :disabled="action.isDisabled"
                                  @click="callItemAction(action.click, element)"
                                >
                                  <md-icon>{{element.added? action.iconAdded : action.icon}}</md-icon>
                                </md-button>
                              </template>
                            </div>
                          </div>
                        </div>
                      </draggable>
                    </div>
                    <div slot="footer" class="row list-group-item item" role="group">
                      <div class="md-layout md-alignment-center-right _footerSlot">
                        <md-button
                          v-if="!list.skipCardLayout" 
                          v-on:click="newRecord(groupIndex)"
                          class="md-button md-primary md-sm _smBtn"
                          :disabled="isCompleteInOrder" 
                        >Add Task<md-icon class="md-small">control_point</md-icon></md-button>
                      </div>
                    </div>
                </div>
              </div>
            </draggable>
          </div>
        </template>
        <template v-else>
            <div class="_group" v-for="(_group, groupIndex) in groups" :key="groupIndex">
              <div class="md-layout-item md-size-100 group-layout">
                <draggable :id="`group-${groupIndex}`" :list="_group" class="list-group" v-bind="dragOptions" draggable=".item" group="group">
                  <div
                    class="list-group-item item"
                    v-for="(element, elementIndex) in orderList(_group,'order')"
                    :key="elementIndex"
                  >{{ element.name }}</div>

                  <div slot="footer" class="row list-group-item item" role="group">
                    <div class="md-layout-item md-size-12">
                      <!--i class="fa fa-align-justify handle"></i-->
                    </div>
                    <div class="md-layout md-alignment-center-right _footerSlot">
                      <button
                        v-if="!list.skipCardLayout"
                        v-on:click="newRecord(groupIndex)"
                        class="md-button md-primary md-sm _smBtn"
                        :disabled="isCompleteInOrder"
                      >Add Task<md-icon class="md-small">control_point</md-icon></button>
                    </div>
                  </div>
                </draggable>
            </div>
          </div>
        </template>
      </md-table>
    </component>

    <md-card-actions md-alignment="space-between">
      <div class="">
        <p v-if="queriedData.length" class="card-category number">
          Showing {{ from + 1 }} to {{ to }} of{{list.nextToken? ' more than': ''}} {{ total }} records
        </p>
        <p v-else class="card-category">
          0 results
        </p>
      </div>

      <!--[i] If you look at pagination component,
      you will see that nextPage and prevPage functions both emit a change to the model value which is currentPage.
      this will kick off another search-->
      <pagination
        class="pagination-no-border pagination-success"
        v-model="currentPage"
        :per-page="list.pagination.perPage"
        :nextToken="list.nextToken"
        :total="total"
        v-on:loadMore="loadMore()"
      >
      </pagination>
    </md-card-actions>

    <!-- ATLAS-681 ElasticSearch error - no results - Alert Dialog -->
    <md-dialog-alert
      class="__alertDialog"
      :md-active.sync="mdAlertDialogShow"
      :md-title="mdAlertTitle"
      :md-content="mdAlertMessage" />

  </component>
</template>

<script>
  import _ from "lodash";
  import { Pagination } from "@/components";
  import Fuse from "fuse.js";
  import Swal from "sweetalert2";
  import draggable from "vuedraggable";
  import { filter } from 'minimatch';
  import moment from 'moment'
  import jquery from 'jquery';

  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as queries from '@/graphql/queries';
  import * as queries_custom from '@/graphql/queries_custom';
  import * as mutations from '@/graphql/mutations';
  import * as subscriptions from '@/graphql/subscriptions';
  import searchConfig from '@/searchConfig';
  import accordion from '@/components/AccordionBasic';
  import gql from "graphql-tag";

  export default {
    props: {
      list: {
        type: Object,
        required: true
      },
      filter: {
        type: Object
      },
      params: {
        type: Object
      },
      relateRecordInput: {
        type: Object
      },
      relateRecordInputField: {
        type: String
      },
      isCompleteInOrder: {
        type: [Boolean, null, undefined],
        required: false
      }
    },
    components: {
      Pagination,
      draggable,
      accordion
    },
    data() {
      return {
        searchQuery: "",
        searchTimeout: null,
        isPromisePending: false,
        currentPage: 1,
        searchConfig: searchConfig,
        groups: [],
        orderedGroups: [],
        isBuildComplete: false,
        isDisabled: true,
        columns: [
          { label: 'Group', isSortable: false, key: '' },
          { label: 'Task', isSortable: true, key: 'subject' },
          { label: 'Status', isSortable: true, key: 'status' },
          { label: 'Is Available', isSortable: true, key: 'isAvailable' },
          { label: 'Quick Note', isSortable: true, key: 'quickNote' },
          { label: 'Assignee', isSortable: true, key: 'assigneeName' },
          { label: 'Due Date', isSortable: true, key: 'dateDueTimestamp' },
          { label: 'Created Date', isSortable: true, key: 'createdAt' },
          { label: 'Actions', isSortable: false, key: '' },
        ],
        sort: {
          isEnabled: false,
          asc: true,
          key: 'createdAt',
        },
        mdAlertTitle: "",
        mdAlertMessage: "",
        mdAlertDialogShow: false
      }
    },
    apollo: {
      subscriptions: {
        query: function() {
          return gql(queries['searchUsers']);
        },
        variables: {
          filter: { id: { eq: '-1' } },
          limit: 1,
        },
        update: () => [],
      }
    },
    watch: {
      groups: {
        deep: true,
        immediate: true,
        handler: function() {
          let groups = [];
          this.groups.map(_group => {
            let sortedGroupItems = _.sortBy(_group, ['order']);
            groups.push(sortedGroupItems);
          });
          this.orderedGroups = groups;
        }
      },
      list: {
        deep: true,
        immediate: true,
        handler: function() {
          if (!this.isBuildComplete && this.list && this.list.tableData && this.list.tableData.length) {
            this.buildGroups();
            this.isBuildComplete = true;
          }
        }
      },
      'list.forceMountedRefresh': {
        handler: function() {
          this.buildGroups();
        }
      },
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {

        let result = this.list.tableData;

        // clearTimeout(this.searchTimeout);
        if (value !== "") {
          result = this.list.fuseSearch.search(this.searchQuery);
        }
        this.list.searchedData = result;

      },
      currentPage(newVal, oldVal) {
        // this.search(this.searchQuery)
        //   .then(response => {
        //     //this.list.searchedData = response;
        //     //  this.data[listName].items =  [...this.data[listName].items, ...response];
        //     /** Add the next page's results to our tableData */
        //     this.list.tableData =  [...this.list.tableData, ...response];
        //     this.$c.log("searchQuery(" + this.searchQuery + ") result:", response);
        //   })
      },
      'dataNeedsUpdate' (to) {
        if (to === true) {
          this.refresh();
        }
      },
      'list.dataNeedsUpdate': {
        handler: function() {
          this.refresh();
        }
      },
    },
    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: this.isCompleteInOrder,
          ghostClass: "ghost"
        };
      },

      dataNeedsUpdate: function () {
        return this.list.refreshData;
      },

      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.list.tableData;
        if (this.list.searchedData.length > 0) {
          this.$c.log("queriedData() using searchedData");
          result = this.list.searchedData;
        }
        return result.length? result.slice(this.from, this.to) : [];
      },
      to() {
        let highBound = this.from + this.list.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.list.pagination.perPage * (this.currentPage - 1);
      },
      total() {
        return this.list.searchedData.length > 0
          ? this.list.searchedData.length
          : this.list.tableData.length;
      },
      sortableColumnNames() {
        let columns = [];
        this.$loopo(this.list.columns, (value, key) => {
          if (value.sortable) columns.push(key);
        });
        this.$c.log(this.list.pageTitle + " sortableColumnNames: ", columns);
        return columns;
      },
      displayColumns() {
        let columns = [];
        this.$loopo(this.list.columns, (value, key) => {
          if (value.display) columns.push(value);
        });
        this.$c.log(this.list.pageTitle + " displayColumns: ", columns);
        return columns;
      }
    },
    methods: {
      onSortChange(col) {
        // if column is not sortable return
        if (!col.isSortable) {
          return;
        }
        
        // update current sort info
        this.$set(this.sort, 'asc', !this.sort.asc);
        this.$set(this.sort, 'key', col.key);
        this.$set(this.sort, 'isEnabled', true);
        
        // create new sorted groups
        const groups = [];
        this.groups.map(_group => {
          // clone group and add assignee name if user is available
          const clonedGroup = _.clone(_group).map(_item => {
            if (_item.user && _item.user.given_name) {
              _item.assigneeName = _item.user.given_name + " " + _item.user.family_name;
            }
            // convert dateDue column to timestamp to fix sorting bug
            try {
              _item.dateDueTimestamp = moment(_item.dateDue).toDate().toISOString();
            } catch (e) {
              _item.dateDueTimestamp = null;
            }
            return _item;
          });
          
          // sort group items
          const sortedGroupItems = _.sortBy(_group, [col.key]);
          if (!this.sort.asc) {
            sortedGroupItems.reverse();
          }
          groups.push(sortedGroupItems);
        });
        
        // assign sorted items
        this.orderedGroups = groups;
      },
      orderList(list, orderBy = 'order') {
        /**
         * if the user has manually sorted the items then bail
         * @see onSortChange function above
         */
        if (this.sort.isEnabled) {
          return list;
        }
        // sort by orderBy column by default
        return _.orderBy(list, orderBy);
      },
      markTaskStepComplete(step) {
        console.log('markTaskStepComplete step', step);
      },
      getItemAsJson(element) {
        return JSON.stringify(element);
      },
      async saveTaskOrder() {
        this.isPromisePending = true;
        const $root = jquery(this.$refs.draggableRoot);
        const $parents = $root.find('[data-parent]');
        const data = [];
        const promiseArr = [];
        let groupIndex = 0;

        $parents.each((_index, _parent) => {
          const $currentParent = jquery(_parent);
          const $childs = $currentParent.find('[data-child]');
          var childItems = [];
          var parentData = {};
          try {
            parentData.data = JSON.parse($currentParent.data('parent'));
          } catch (e) {
            parentData.data = $currentParent.data('parent');
          }
          $childs.each((_childIndex, _child) => {
            let $currentChild = jquery(_child);
            let childData;
            try {
              childData = JSON.parse($currentChild.data('child'));
            } catch (e) {
              childData = $currentChild.data('child');
            }
            childItems.push(childData);
          });
          if (!childItems.length) {
            return;
          }
          groupIndex++;
          childItems = childItems.map(_child => {
            _child.group = groupIndex;
            return _child;
          });
          parentData.items = childItems;
          data.push(parentData);
        });
        data.forEach((_element, _elementIndex) => {
          _element.items.forEach((_itemElement, _itemIndex) => {

            let updateTaskOrder = {
              id: _itemElement.id,
              order: _itemIndex + 1,
              group: _elementIndex + 1
            }

            let gqlRequest = API.graphql(graphqlOperation(mutations['updateTask'], {input: updateTaskOrder}));
            promiseArr.push(gqlRequest);
          });
        });

        Promise.allSettled(promiseArr).then((resultPromise) => {
          this.isPromisePending = false;
          this.$c.log('Group Tasks Order Updated Successfully');
          this.isDisabled = true;
        });
      },
      buildGroups(payload) {
        const groups = [];
        this.list.tableData.map((_item) => {
          if (undefined === _item.group || null === _item.group) {
            return;
          }
          if (!groups[_item.group]) {
            groups[_item.group] = [];
          }
          groups[_item.group].push(_item);
        });
        this.groups = [];
        groups.map(_group => {
          if (_group.length) {
            this.groups.push(_group);
          }
        });
        if (!this.groups.length) {
          this.groups.push([]);
        }

        if (payload && this.groups[payload.groupId]) {
          this.groups[payload.groupId].push(payload.item);
          this.isBuildComplete = true;
        }
      },

      addGroup (){
        this.groups.push([0]);
      },
      dragend() {
        this.isDisabled = false;
      },

      callItemAction(funcName, item) {
        if (typeof this[funcName] === 'function') {
          return this[funcName](item);
        }
      },
      async loadMore() {
        this.$c.log('loadMore()...');

        this.search(this.searchQuery, true)
          .then(response => {
            if (!response.length) {
              this.$c.log('loadMore() End of results reached');
            } else {
              this.$c.log('loadMore() Response:', response);
              /** Add the next page's results to our tableData */
              this.list.tableData =  [...this.list.tableData, ...response];
              this.$c.log('loadMore() Incrementing currentPage:', this.currentPage);
              let targetPage = this.currentPage + 1;

              // Fuse search initialization.
              this.list.fuseSearch = new Fuse(this.list.tableData, {
                keys: this.sortableColumnNames,
                threshold: 0.3,
              });

              //TODO: Hook up to fuse.js event if possible
              // Using a timeout for now. :/
              this.$nextTick(() => {
                setTimeout(() => {
                  this.currentPage = targetPage;
                  this.$c.log('LOADING MORE Incrementing currentPage verify:', this.currentPage);
                }, 250);
              });
            }
          });
      },
      async refresh() {
        this.$c.log('refresh has been called')

        const result = await this.search();
        this.list.tableData = result;
        this.list.refreshData = false;
      },
      getColumnDisplayValue(column, item, name) {
        let result = '';
        if (typeof item === 'undefined' || typeof item[name] === 'undefined') return result;

        if (typeof column.nested !== 'undefined' && typeof item[name][column.nested]!== 'undefined') {
          result = item[name][column.nested];
        } else {
          result = item[name];
        }
        return result;
      },
      getSearchConfig() {
        const listQueryId = this.list.listQueryId;
        let objectName = listQueryId.substring(0, listQueryId.length - 1).replace('list', '');
        return this.searchConfig[objectName];
      },
      async delete(item) {

        let idField = 'id';
        if (typeof this.list.deleteQueryIdField !== 'undefined') {
          idField = this.list.deleteQueryIdField;
        }

        this.$c.log(this.list.pageTitle + " deleting record:", item[idField]);
        await API.graphql(graphqlOperation(mutations[this.list.deleteQueryId], {input: {"id": item[idField]}}))
          .then(this.afterDelete(item))
          .catch(error => {
            this.$c.log(this.list.pageTitle + " delete record error:", error);
        });

      },

      async deleteLink(item) {
        let idField = 'id';
        if (typeof this.list.updateQueryIdField !== 'undefined') {
          idField = this.list.updateQueryIdField;
        }
        let input = {};
        input['id'] = item.id ;
        input[this.list.updateQueryIdField] = null;

        await API.graphql(graphqlOperation(mutations[this.list.updateQueryId], {input: input}))
          .then(this.afterDelete(item))
          .catch(error => {
            this.$c.log(this.list.pageTitle + " delete record error:", error);
          });

      },
      async add(item) {
        this.$c.log(this.list.pageTitle + " adding record:", item.id);

        let input = this.relateRecordInput;
        input[this.relateRecordInputField] = item.id;

        await API.graphql(graphqlOperation(mutations[this.list.createMutationId], {input: input}))
          .then(this.afterAdd(item))
          .catch(error => {
            this.$c.log(this.list.pageTitle + " adding record error:", error);
          });
      },
      afterAdd(item) {
        this.$c.log(this.list.pageTitle + " add record success!");
        item.added = true;
        setTimeout(() => {
          this.$emit('relationshipAdded', item);
          this.deleteRow(item);
        }, 500)
      },
      afterDelete(item) {
        this.$c.log(this.list.pageTitle + " delete record success!");
        this.deleteRow(item);
        Swal.fire({
          title: "Deleted",
          text: `You deleted ${item.subject}`,
          type: "success",
          confirmButtonClass: "md-button md-success btn-fill",
          buttonsStyling: false
        });
      },
      newRecord(groupIndex) {
        if (typeof this.list.showRelatedDialog !== 'undefined') {
          this.list.showRelatedDialog = true;
          this.$emit('groupChange', (groupIndex + 1));
          this.$emit('orderChange', (this.groups[groupIndex].length + 1));
          return;
        }

        if (typeof this.filter === 'undefined') {
          this.$router.push("/" + this.list.editPath + '/new');
        } else {
          this.$loopo(this.filter, (item, name) => {
            this.$router.push("/" + this.list.editPath + '/new?' + name + '=' + item.eq);
          });
        }
      },
      customSort(value) {
        return value.sort((a, b) => {
          const sortBy = this.list.currentSort;
          let aSortBy = typeof a[sortBy] !== "undefined" && a[sortBy] !== null? a[sortBy] : "";
          let bSortBy = typeof b[sortBy] !== "undefined" && b[sortBy] !== null? b[sortBy] : "";
          if (this.list.currentSortOrder === "desc") {
            return aSortBy.localeCompare(bSortBy);
          }
          return bSortBy.localeCompare(aSortBy);
        });
      },
      handleEdit(item) {
        this.$Session.tempRedirect = this.$route.path;
        //console.log(this.$Session, " --> session data")
        this.$router.push({ path: "/" + this.list.editPath + "/" + item.id});
      },
      handleAdd(item) {
        this.add(item);
      },
      handleLinkDelete() {

      },
      handleDelete(item) {
        
        //build the name first
        let nameFields = this.list.deleteMessageNameFields ? this.list.deleteMessageNameFields : ['name'];
        let objectName = '';
        nameFields.forEach((nf, index) => {
          objectName += item[nf];
          if (index !== nameFields.length -1) objectName += ' ';
        });

        // without at least 1 character this will use the default on the right
        let title = this.list.deleteMessageTitle ? this.list.deleteMessageTitle : "Are you sure you want to delete {objectName}?";
        title = title.replace('{objectName}', objectName);

        //this test is different because we want to allow config of '' to omit the default text
        let text = typeof this.list.deleteMessageText !== 'undefined' ? this.list.deleteMessageText : `The change cannot be undone.`;

        Swal.fire({
          title: title,
          text: text,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Yes",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            if (typeof this.list.linkActive !== 'undefined' && (this.list.linkActive == true)) {
              this.deleteLink(item);
            } else {
              this.delete(item);
            }
          }
        });
      },
      deleteRow(item) {
        this.$emit('deleteRow', item);
        let indexToDelete = this.list.tableData.findIndex(
          tableRow => tableRow.id === item.id
        );
        if (indexToDelete >= 0) {
          this.list.tableData.splice(indexToDelete, 1);
        }
      },
      async search(searchString, useNextToken) {
        const listQueryId = this.list.listQueryId;
        this.$c.log(listQueryId + " search(" + searchString + ")");

        const searchMethod = listQueryId.substring(0, 6) === 'search'? 'wildcard' : 'contains';
        let params = {};
        if(this.list.pagination.perPageMaxLimit) {
          console.log('in if customTaskList');
          params = {
            "limit": this.list.pagination.perPageMaxLimit
          };
        } else {
          console.log('in else customTaskList');
          params = {
            "limit": this.list.pagination.perPage
          };
        }

        if (useNextToken && this.list.nextToken) {
          params.nextToken = this.list.nextToken;
        }

        let filters = [], operation;

        //if (typeof searchString !== 'undefined' && searchString !== "" && this.list.searchFields) {
        if (typeof searchString !== 'undefined' && searchString !== "") {
          let searchConfig = this.getSearchConfig();

          searchConfig.searchFields.forEach((searchField) => {
            let test = {};
            test[searchField] = {};//{contains: searchString};
            test[searchField][searchMethod] = '*' + searchString + '*';
            filters.push(test);
          });
        }
        this.$c.log(listQueryId + " search(" + searchString + ") filters: ", filters);

        if (typeof this.filter !== 'undefined') {
          //filters.push(this.list.filter);
          if (filters.length > 1) {
            params.filter = {and: [
                this.filter,
                {or: filters}
              ]};
          } else if (filters.length === 1) {
            params.filter ={and: [
                this.filter,
                filters[0]
              ]};
          } else {
            params.filter = this.filter;
          }
        } else {
          if (filters.length > 1) {
            params.filter = {or: filters};
          } else if (filters.length === 1) {
            params.filter = filters[0];
          }
        }

        if (typeof this.params !== 'undefined') {
          this.$loopo(this.params, (param, paramName) => {
            params[paramName] = param;
          });
        }

        this.$c.log(listQueryId + " search(" + searchString + ") params: ", params);

        //Get the correct query
        let query = queries[listQueryId];
        if (typeof query === 'undefined') {
          query = queries_custom[listQueryId];
        }

        params.fetchPolicy = 'network-only';
        operation = graphqlOperation(query, params, {
          fetchPolicy: 'network-only'
        });

        this.$c.log(listQueryId + " search(" + searchString + ") operation: ", operation);

        this.isPromisePending = true;
        let result;
        try {
          result = await API.graphql(operation);
        } catch (e) {
          this.isPromisePending = false;
          result = {};
        }
        
        this.$c.log(listQueryId + " search(" + searchString + ") Results Raw:", result.data);
        let response = false;

        let lookup = listQueryId;
        if (this.list.responseFieldName) lookup = this.list.responseFieldName;

        if (result.data && result.data[lookup]) {
          let data = result.data[lookup];
          this.$c.log('oldNextToken: [' + this.list.nextToken + ']');
          this.$c.log('newNextToken: [' + data.nextToken + ']');

          if (data.nextToken !== this.list.nextToken) {
            this.list.nextToken = data.nextToken;
          } else {
            this.list.nextToken = false;
          }
          if (typeof this.list.formatResponse === 'function') {
            response = this.list.formatResponse(result.data);
          } else if (data.items) {
            response = data.items;
          }
        }

        /**
         * ATLAS-681 ElasticSearch error - no results
         * Show alert dialog
         * 
         * ATLAS-793 Getting Error Screen when no data found
         * Hide alert dialog
         */
        if (typeof result.errors !== 'undefined' && result.errors.length) {
            this.$c.log(result);
            let skipError = "Elasticsearch responded with an error: Not Found";
            let errorMsg = result.errors[0].message;

            if (errorMsg && !errorMsg.includes(skipError)) {
              this.mdAlertTitle = "Error";
              this.mdAlertMessage = "Search Error, reload the page";
              this.mdAlertDialogShow = true;
            }
        }

        this.$c.log(listQueryId + " search(" + searchString + ") Results Formatted:", response);
        this.isPromisePending = false;
        return response;
      },
    },
    filters: {
      formatDate: function(value) {
        if (value) {
          return moment(String(value)).format('MMM DD, YYYY')
        }
      }
    },
    async mounted() {
      //this.addLine();
      this.buildGroups();

      /*window.bus.$on('groupRefresh', (payload) => {
        console.log(payload);
        this.isBuildComplete = false;
        this.buildGroups(payload);
      });*/

      if (this.list.tableData.length === 0 || this.list.forceMountedRefresh) {
        const result = await this.search();
        this.list.tableData = result;

        // Fuse search initialization.
        this.list.fuseSearch = new Fuse(this.list.tableData, {
          keys: this.sortableColumnNames,
          threshold: 0.3
        });

        this.$c.log(this.list.listQueryId + " mounted() this.list.tableData:", this.list.tableData);
      }


      if (this.list.subscriptions) {
        this.$loopo(this.list.subscriptions, (sub, name) => {
          this.$c.log('SUBSCRIPTION CONFIGURED: ' + name);

          if (typeof subscriptions[name] === 'undefined') {
            this.$c.error('SUBSCRIPTION [' + name + '] not found!');
            return;
          }

          let thisFunc = this.list.subscriptions[name].function;
          this.$apollo.queries.subscriptions.subscribeToMore({
            document: gql(subscriptions[name]),
            updateQuery: (previousResult, { subscriptionData }) => {
              console.log('SUBSCRIPTION ', name, subscriptionData);
              thisFunc({ value: subscriptionData });
            },
          });
        });
      }
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }

  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }

  .step-layout{
    border: 0.5px solid #ccc; 
    background-color: #f4fcfc;
    padding: 10px 0;
    /*max-height: 60px;*/
  }
  .md-layout-item.md-size-100.group-layout {
    border: 1px solid grey;
    padding: 0px;
    overflow: auto;
    margin-bottom: 3px;
  }
  .handle {
    float: left;
    padding-top: 5px;
    padding-bottom: 0px;
    margin-right: 10px;
  }
  .field-layout .md-field{
    padding-bottom: 8px;
    margin: 5px 0 0;
  }
  div .md-button:not([disabled]) {
    height: 32px;
    padding: 5px;
  }
  button.md-button.md-primary.md-sm.add-group-btn {
    float: left;
    margin: -30px 0px 0px 30px;
    padding: 2px 5px;
  }
  .md-button i {
    width: 24px;
    min-width: 24px;
    margin-left: 5px;
  }
  .md-layout-item .md-size-5{
    padding-top: 10px;
    padding-bottom: 26px;
  }
  h5.title {
    margin-bottom: 10px !important;
  }
  h4.title {
    margin-top:1px !important;
  }
  .align-input { 
    padding-top:9px; 
  }

  .md-card .md-card-content .md-form-label{
    text-align: left;
  }

  ._parentGroup {
    position: relative;
  }
  ._parentGroup__handle {
    position: absolute;
    top: 1rem;
    left: -2rem;
  }
  ._root {
     padding: 0 2rem;
     padding-right: 0px;
  }
  .fieldText__fix {
    padding: 0px 0px;
  }
  ul.case-task-steps {
    list-style: none;
    padding-left: 15px;
    margin-top: 0;
  }
  .overFlow {
    overflow-wrap: break-word;
  }
  
  ._sortableHeader {
    padding: 0 2rem;
  }

  /* md-alert-dialog width */
  .md-dialog.__alertDialog.md-theme-default {
    width: 50% !important;
  }
</style>

<style lang="scss">
  ._breakWord {
    word-break: break-all;
  }
</style>